import { Button, Container, Paper, Stack, Text, Title } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default function HotelPaymentCancelPage() {
    const navigate = useNavigate();

    return (
        <Container size="sm" py="xl">
            <Paper withBorder radius="lg" p="xl">
                <Stack align="center" gap="md">
                    <IconX size={54} color="red" />

                    <Title order={2}>Payment cancelled</Title>

                    <Text c="dimmed" ta="center">
                        The payment was cancelled. You can use the payment link again
                        if the deadline has not passed.
                    </Text>

                    <Button variant="light" onClick={() => navigate("/")}>
                        Back to frontpage
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}